import React, { useRef, useEffect } from 'react';
import * as constantsViewer from '../../constants';
import { useSpring, a } from 'react-spring/three';
import { AdjustableFeetBatten, FeetBatten } from '../pieces/Batten';
import { Sabot } from '../pieces/Sabot';
import { SABOT_HEIGHT } from 'lib/modelBuilder/constants';
import { Wheel, WheelsBasePlate } from '../pieces/Wheel';

export const BottomSupport = ({
  type,
  cabinet,
  cabinetHeight,
  cabinetWidth,
  cabinetDepth,
  bottomSupportHeight,
  unselected = false,
}) => {
  let bottomSupport = null;
  let position = [0, 0, 0];
  switch (type) {
    case 'F':
      bottomSupport = (
        <>
          <FeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="FL"
            battenHeight={bottomSupportHeight}
            unselected={unselected}
          />
          <FeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="FR"
            battenHeight={bottomSupportHeight}
            unselected={unselected}
          />
          <FeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="BL"
            battenHeight={bottomSupportHeight}
            unselected={unselected}
          />
          <FeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="BR"
            battenHeight={bottomSupportHeight}
            unselected={unselected}
          />
        </>
      );
      break;

    case 'A':
      const feetsMaterial =
        cabinet.feets &&
        cabinet.feets.length > 0 &&
        cabinet.feets[0].base.material
          ? cabinet.feets[0].base.material
          : 'A';
      const battenHeight = bottomSupportHeight - SABOT_HEIGHT;
      position = [0, SABOT_HEIGHT, 0];
      bottomSupport = (
        <>
          <AdjustableFeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="FL"
            battenMaterial={feetsMaterial}
            battenHeight={battenHeight}
            unselected={unselected}
          />
          <AdjustableFeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="FR"
            battenMaterial={feetsMaterial}
            battenHeight={battenHeight}
            unselected={unselected}
          />
          <AdjustableFeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="BL"
            battenMaterial={feetsMaterial}
            battenHeight={battenHeight}
            unselected={unselected}
          />
          <AdjustableFeetBatten
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            battenPosition="BR"
            battenMaterial={feetsMaterial}
            battenHeight={battenHeight}
            unselected={unselected}
          />
          <Sabot
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            sabotPosition="FL"
            battenHeight={battenHeight}
            unselected={unselected}
          />
          <Sabot
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            sabotPosition="FR"
            battenHeight={battenHeight}
            unselected={unselected}
          />
          <Sabot
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            sabotPosition="BL"
            battenHeight={battenHeight}
            unselected={unselected}
          />
          <Sabot
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            sabotPosition="BR"
            battenHeight={battenHeight}
            unselected={unselected}
          />
        </>
      );
      break;

    case 'W':
    case 'B':
      bottomSupport = (
        <>
          <WheelsBasePlate
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            cabinetHeight={cabinetHeight}
            color={type}
            unselected={unselected}
          />
          {cabinet.wheels.map(wheel => (
            <Wheel
              key={wheel.position}
              cabinetWidth={cabinetWidth}
              cabinetDepth={cabinetDepth}
              cabinetHeight={cabinetHeight}
              wheelPosition={wheel.position}
              unselected={unselected}
            />
          ))}
        </>
      );
      break;

    default:
      break;
  }

  const group = useRef();

  const [spring, set] = useSpring(() => ({
    position: position,
    immediate: !constantsViewer.REACT_SPRING_ANIMATIONS_ACTIVE,
    config: constantsViewer.REACT_SPRING_ANIMATIONS_CONF,
  }));

  useEffect(() => {
    let self = group.current;
    if (self) {
      set({
        position: position,
      });
    }
  });

  return bottomSupport ? (
    <a.group ref={group} position={spring.position}>
      {bottomSupport}
    </a.group>
  ) : null;
};
